import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import cleanObj from 'utils/cleanObj';
import App from './index';

// Script to initialise Filter Listing React component on all .listing-app elements
$('.algolia-filter').each(function () {
    const $el = $(this);
    const appIndex = $el.data('app-index');
    const appId = $el.data('app-id');
    const appKey = $el.data('app-key');
    const contentTypeName = $el.data('content-type-name');
    const contentFilters = $el.data('content-filters');
    const contentFiltersPlural = $el.data('content-filters-plural') || {};
    const contentFiltersPseudonym = $el.data('content-filters-pseudonym') || {};
    const noKeyword = $el.data('no-keyword');
    const mediaContactTitle = $el.data('media-contact-title');
    const mediaContactName = $el.data('media-contact-name');
    const mediaContactPhone1 = $el.data('media-contact-phone1');
    const mediaContactPhone2 = $el.data('media-contact-phone2');
    const mediaContactEmail = $el.data('media-contact-email');
    const defaultFilter = $el.data('default-filter');
    const loadInitialContent = $el.data('load-initial-content');

    // Early return if div target is not specified
    if (!contentTypeName) { return; }

    // Setup props
    const props = {
        appIndex,
        appId,
        appKey,
        contentTypeName,
        contentFilters,
        contentFiltersPlural,
        contentFiltersPseudonym,
        noKeyword,
        mediaContactName,
        mediaContactPhone1,
        mediaContactPhone2,
        mediaContactEmail,
        mediaContactTitle,
        defaultFilter,
        loadInitialContent
    };

    // Remove any empty prop settings to let the default prop values kick in
    cleanObj(props);

    ReactDOM.render(
        React.createElement(App, props, null),
        $el[0]
    );
});




// WEBPACK FOOTER //
// ./src/sections/algolia-filter/s-algolia-filter.jsx